/* unplugin-vue-components disabled */import { render } from "./GuZhu.vue?vue&type=template&id=b7b93bb6&scoped=true"
const script = {}

import "./GuZhu.vue?vue&type=style&index=0&id=b7b93bb6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b93bb6"]])

export default __exports__